import BookingSchedule from "./BookingSchedule";

export default BookingSchedule;
